<script setup lang="ts">
useHead({
  title: 'Sarpsborgveien legesenter',
  meta: [
    { name: 'description', content: 'Sarpsborgveien legesenter' },
  ],
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
  ],
});
</script>
<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
